import { create } from 'zustand';
import { GUESTS_TYPE } from '../../constants';

export const createPromoCodesSlice = (set, get) => ({
  promoCodes: [],
  setPromoCodes: (promoCodes) => set({ promoCodes }),
  promoCodesAdd: (code) => set({
    promoCodes: [
      ...get().promoCodes,
      {
        key: code.key || Math.random().toString(36).slice(2),
        ...code,
      },
    ],
  }),
  promoCodesRemove: (key) => set({
    promoCodes: get().promoCodes?.filter((code) => code.key !== key),
  }),
});
